/**
 * Component: sa-shop-by-category
 * Description: Shop by category — 桌面端 hover 闪烁 + 移动端滑动切换
 */
if (!customElements.get('sa-shop-by-category')) {
  class SaShopByCategory extends HTMLElement {
    constructor() {
      super();
      this.mobileSwiperInstance = null;
      this.currentActiveIndex = 0;
      this.isSwitchingByClick = false;
      this.mobileNavItems = [];
      this.activeTimeouts = [];
      this.initMobileSwiper = this.initMobileSwiper.bind(this);
      this.initMobileNav = this.initMobileNav.bind(this);
      this.handleMobileNavClick = this.handleMobileNavClick.bind(this);
      this.scrollNavItemIntoView = this.scrollNavItemIntoView.bind(this);
      this.initHoverBlink = this.initHoverBlink.bind(this);
    }

    connectedCallback() {
      if (typeof Swiper === 'undefined') {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.initMobileSwiper();
            this.initMobileNav();
          });
        } else {
          setTimeout(() => {
            this.initMobileSwiper();
            this.initMobileNav();
            this.initHoverBlink();
          }, 100);
        }
      } else {
        this.initMobileSwiper();
        this.initMobileNav();
        this.initHoverBlink();
      }
    }

    disconnectedCallback() {
      if (this.mobileSwiperInstance) {
        this.mobileSwiperInstance.destroy(true, true);
        this.mobileSwiperInstance = null;
      }
      this.mobileNavItems.forEach((item) => {
        item.removeEventListener('click', this.handleMobileNavClick);
      });
      this.mobileNavItems = [];
      this.activeTimeouts.forEach((timeout) => {
        clearTimeout(timeout);
      });
      this.activeTimeouts = [];
      if (this._hoverTargets && this._hoverEnterHandler) {
        this._hoverTargets.forEach((el) => {
          el.removeEventListener('mouseenter', this._hoverEnterHandler);
        });
        this._hoverTargets = [];
        this._hoverEnterHandler = null;
      }
    }

    // ========== 移动端图片 Swiper ==========
    initMobileSwiper() {
      const mobileSwiperContainer = this.querySelector('.sa-shop-by-category__mobile-main-image.swiper');
      if (!mobileSwiperContainer || typeof Swiper === 'undefined') {
        return;
      }

      const spaceBetween = parseInt(this.getAttribute('data-space-between')) || 10;

      const swiperOptions = {
        loop: false,
        speed: 600,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: spaceBetween,
        grabCursor: true,
        allowTouchMove: true,
        on: {
          init: (swiper) => {
            mobileSwiperContainer.classList.add('swiper-initialized');
            this.updateScrollbar(swiper);
            this.updateDescription(0);
          },
          slideChange: (swiper) => {
            if (!this.isSwitchingByClick) {
              this.switchToBlock(swiper.activeIndex, true);
            }
            this.isSwitchingByClick = false;
            this.updateScrollbar(swiper);
            this.updateDescription(swiper.activeIndex);
          },
        },
      };

      this.mobileSwiperInstance = new Swiper(mobileSwiperContainer, swiperOptions);
    }

    // ========== 移动端标题导航 ==========
    initMobileNav() {
      const navItems = Array.from(this.querySelectorAll('.sa-shop-by-category__mobile-nav-item'));
      if (navItems.length === 0) return;
      this.mobileNavItems = navItems;
      navItems.forEach((item) => {
        item.addEventListener('click', this.handleMobileNavClick);
      });
    }

    handleMobileNavClick(e) {
      e.preventDefault();
      const button = e.currentTarget;
      const blockIndex = parseInt(button.getAttribute('data-block-index'));
      if (blockIndex === this.currentActiveIndex) return;
      this.isSwitchingByClick = true;
      if (this.mobileSwiperInstance) {
        this.mobileSwiperInstance.slideTo(blockIndex);
      }
      this.switchToBlock(blockIndex, false);
      const timeout = setTimeout(() => {
        this.isSwitchingByClick = false;
      }, 600);
      this.activeTimeouts.push(timeout);
    }

    scrollNavItemIntoView(navItem) {
      const navContainer = this.querySelector('.sa-shop-by-category__mobile-nav');
      if (!navContainer || !navItem) return;
      if (window.innerWidth >= 768) return;
      const navWrapper = this.querySelector('.sa-shop-by-category__mobile-nav-wrapper');
      if (!navWrapper) return;
      const containerWidth = navContainer.getBoundingClientRect().width;
      const paddingLeft = parseInt(getComputedStyle(navContainer).paddingLeft || '0', 10) || 0;
      let targetLeft = navItem.offsetLeft - paddingLeft - 10;
      const maxScroll = Math.max(0, navWrapper.scrollWidth - containerWidth);
      targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));
      navContainer.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    switchToBlock(index, isSwipeTransition = false) {
      const navItems = this.mobileNavItems.length > 0
        ? this.mobileNavItems
        : Array.from(this.querySelectorAll('.sa-shop-by-category__mobile-nav-item'));
      const imageItems = Array.from(this.querySelectorAll('.sa-shop-by-category__mobile-image-item'));
      if (navItems.length === 0 || imageItems.length === 0) return;
      this.currentActiveIndex = index;

      navItems.forEach((item, i) => {
        if (i === index) {
          item.classList.add('sa-shop-by-category__mobile-nav-item--active');
          const titleEl = item.querySelector('.sa-shop-by-category__mobile-nav-title');
          if (titleEl) {
            titleEl.classList.remove('sa-shop-by-category__mobile-nav-title--blink');
            const t1 = setTimeout(() => {
              titleEl.classList.add('sa-shop-by-category__mobile-nav-title--blink');
              const t2 = setTimeout(() => {
                titleEl.classList.remove('sa-shop-by-category__mobile-nav-title--blink');
              }, 600);
              this.activeTimeouts.push(t2);
            }, 10);
            this.activeTimeouts.push(t1);
          }
          const st = setTimeout(() => { this.scrollNavItemIntoView(item); }, 50);
          this.activeTimeouts.push(st);
        } else {
          item.classList.remove('sa-shop-by-category__mobile-nav-item--active');
          const titleEl = item.querySelector('.sa-shop-by-category__mobile-nav-title');
          if (titleEl) titleEl.classList.remove('sa-shop-by-category__mobile-nav-title--blink');
        }
      });

      imageItems.forEach((item, i) => {
        const imgEl = item.querySelector('.sa-shop-by-category__mobile-main-img');
        const placeholderEl = item.querySelector('.sa-shop-by-category__mobile-placeholder');
        if (i === index) {
          item.classList.add('sa-shop-by-category__mobile-image-item--active');
          if (isSwipeTransition) {
            if (imgEl) {
              imgEl.classList.add('sa-shop-by-category__mobile-main-img--zoom');
              const zt = setTimeout(() => { imgEl.classList.remove('sa-shop-by-category__mobile-main-img--zoom'); }, 400);
              this.activeTimeouts.push(zt);
            } else if (placeholderEl) {
              placeholderEl.classList.add('sa-shop-by-category__mobile-placeholder--zoom');
              const pt = setTimeout(() => { placeholderEl.classList.remove('sa-shop-by-category__mobile-placeholder--zoom'); }, 400);
              this.activeTimeouts.push(pt);
            }
          }
        } else {
          item.classList.remove('sa-shop-by-category__mobile-image-item--active');
          if (imgEl) imgEl.classList.remove('sa-shop-by-category__mobile-main-img--zoom');
          if (placeholderEl) placeholderEl.classList.remove('sa-shop-by-category__mobile-placeholder--zoom');
        }
      });
    }

    // ========== 更新外部描述文字 ==========
    updateDescription(index) {
      const descEl = this.querySelector(':scope > .sa-shop-by-category__container > .sa-shop-by-category__mobile-description');
      if (!descEl) return;
      const gridCards = Array.from(this.querySelectorAll('.sa-shop-by-category__card-wrapper'));
      if (gridCards[index]) {
        const desc = gridCards[index].querySelector('.sa-shop-by-category__description');
        if (desc) { descEl.innerHTML = desc.innerHTML; return; }
      }
      descEl.innerHTML = '';
    }

    // ========== 移动端 Scrollbar ==========
    updateScrollbar(swiper) {
      const scrollbar = this.querySelector('.sa-shop-by-category__scrollbar-track');
      if (!scrollbar || !swiper || !swiper.slides) return;
      const totalSlides = swiper.slides.length;
      if (totalSlides === 0) return;
      const trackWidth = 100 / totalSlides;
      const offset = totalSlides > 1 ? (swiper.activeIndex / (totalSlides - 1)) * (100 - trackWidth) : 0;
      scrollbar.style.width = trackWidth + '%';
      scrollbar.style.left = offset + '%';
    }

    // ========== 桌面端 hover 闪烁 ==========
    initHoverBlink() {
      const imageWrappers = Array.from(this.querySelectorAll('.sa-shop-by-category__image-wrapper'));
      if (imageWrappers.length === 0) return;
      const handleEnter = (e) => {
        if (window.innerWidth < 768) return;
        const wrapper = e.currentTarget;
        const card = wrapper.closest('.sa-shop-by-category__card');
        if (!card) return;
        const titleEl = card.querySelector('.sa-shop-by-category__title');
        if (!titleEl) return;
        titleEl.classList.remove('sa-shop-by-category__title--blink');
        void titleEl.offsetWidth;
        titleEl.classList.add('sa-shop-by-category__title--blink');
        const timeout = setTimeout(() => {
          titleEl.classList.remove('sa-shop-by-category__title--blink');
        }, 1100);
        this.activeTimeouts.push(timeout);
      };
      imageWrappers.forEach((el) => { el.addEventListener('mouseenter', handleEnter); });
      this._hoverTargets = imageWrappers;
      this._hoverEnterHandler = handleEnter;
    }
  }

  customElements.define('sa-shop-by-category', SaShopByCategory);
}
